function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var _excluded = ["children", "radioName", "groupTitle", "hideGroupTitle", "horizontal", "onChange", "selectedValue", "fieldMessage", "hasError", "className"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import React, { Component } from 'react';
import { string, bool, node, func } from 'prop-types';
import classNames from 'classnames';
import uuid from 'uuid';
import Fieldset from '../Fieldset/Fieldset';
import FieldMessage from '../FieldMessage/FieldMessage';
import './RadioList.scss';
var propTypes = {
  /** Use `<Radio>` component as children of the `RadioGroup` */
  children: node.isRequired,

  /** Sets the name attr on all radios in the group */
  radioName: string.isRequired,

  /** Sets the title of the group (The legend of the fieldset) */
  groupTitle: string.isRequired,

  /** Visually hides the group title. */
  hideGroupTitle: bool,

  /** List the radio buttons horizontally */
  horizontal: bool,

  /** The value that should be marked as selected */
  selectedValue: string,

  /** Callback function for all the radios in the group. Used to control the selected value. */
  onChange: func,

  /** Add your own custom class names to the component */
  className: string
};
var defaultProps = {
  hideGroupTitle: false,
  horizontal: false
};
/** A list of radio buttons where the user can choose **single** option out of a set options.
 * @visibleName Radio List
 * */

var RadioList = /*#__PURE__*/function (_Component) {
  _inherits(RadioList, _Component);

  var _super = _createSuper(RadioList);

  function RadioList(props) {
    var _this;

    _classCallCheck(this, RadioList);

    _this = _super.call(this, props);
    _this.fieldMessageId = "rds-radiolist-fieldmessage-".concat(uuid.v4());
    return _this;
  }

  _createClass(RadioList, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          radioName = _this$props.radioName,
          groupTitle = _this$props.groupTitle,
          hideGroupTitle = _this$props.hideGroupTitle,
          horizontal = _this$props.horizontal,
          onChange = _this$props.onChange,
          selectedValue = _this$props.selectedValue,
          fieldMessage = _this$props.fieldMessage,
          hasError = _this$props.hasError,
          className = _this$props.className,
          rest = _objectWithoutProperties(_this$props, _excluded);

      var childrenWithName = React.Children.map(children, function (child) {
        return /*#__PURE__*/React.createElement("li", {
          className: "rds-radio-list__item"
        }, /*#__PURE__*/React.cloneElement(child, {
          name: radioName,
          onChange: onChange,
          selectedValue: selectedValue
        }));
      });
      var componentClassName = classNames('rds-radio-list', className);
      var radioListClassNames = classNames('rds-radio-list__content', {
        'rds-radio-list__content--horizontal': horizontal
      });
      return /*#__PURE__*/React.createElement(Fieldset, _extends({
        legend: groupTitle,
        className: componentClassName,
        hideLegend: hideGroupTitle,
        renderLegendAsLabel: true
      }, fieldMessage && {
        'aria-describedby': this.fieldMessageId
      }, rest), /*#__PURE__*/React.createElement("ul", {
        className: radioListClassNames
      }, childrenWithName), fieldMessage && /*#__PURE__*/React.createElement(FieldMessage, {
        text: fieldMessage,
        skin: hasError ? 'danger' : null,
        id: this.fieldMessageId
      }));
    }
  }]);

  return RadioList;
}(Component);

RadioList.propTypes = propTypes;
RadioList.defaultProps = defaultProps;
export default RadioList;